function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  document.querySelectorAll(`[data-section="${event.detail.sectionId}"]`).forEach((element) => {
    element.remove();
    document.body.classList.remove('overflow-hidden');
  });
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());


window.addToCart = function(variantId, quantity = 1) {
  if (!variantId) {
    console.error("Variant ID is missing!");
    alert("Failed to add to cart. Please try again.");
    return;
  }

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(errorData => {
          console.error("Error response:", errorData);
          throw new Error(errorData.description || "Failed to add to cart.");
        });
      }
      return response.json();
    })
    .then(data => {
      console.log("Product added to cart:", data);
      // Redirect to the cart page after successfully adding the product
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error("Error adding product to cart:", error.message);
      alert("Failed to add to cart: " + error.message);
    });
};

// Bind "Add to Cart" buttons dynamically
document.addEventListener("DOMContentLoaded", function() {
  const buttons = document.querySelectorAll(".add-to-cart");

  buttons.forEach(button => {
    button.addEventListener("click", function() {
      const variantId = this.getAttribute("data-id");
      const quantity = this.getAttribute("data-quantity") || 1;

      console.log("Adding product to cart:", { variantId, quantity });

      window.addToCart(variantId, quantity);
    });
  });
});
